import { render, staticRenderFns } from "./OfferEvaluationPageInternalProjectDetails.vue?vue&type=template&id=fb53369c&"
import script from "./OfferEvaluationPageInternalProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./OfferEvaluationPageInternalProjectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb53369c')) {
      api.createRecord('fb53369c', component.options)
    } else {
      api.reload('fb53369c', component.options)
    }
    module.hot.accept("./OfferEvaluationPageInternalProjectDetails.vue?vue&type=template&id=fb53369c&", function () {
      api.rerender('fb53369c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/OfferEvaluationPageInternalProjectDetails.vue"
export default component.exports